module.exports = __webpack_public_path__ + "static/media/blog-1.0794949b.jpg";